import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })
  return useMemo(() => {
    if (!data) return data

    return {
      ...data,
      location_ids: [location_id],
    }
  }, [data, location_id])
}
